import { createRoute, redirect } from "@tanstack/react-router";
import { rootRoute } from "../root-route";
import { HomePage } from "./home";
import { jeuParDefaut } from "./jeu";
import { livreCharge } from "./livre";

/**
 * Routes de l'app. Fichier possede par l'app : `src/router.tsx` (template) les ajoute a
 * l'arbre a cote de celles de la couche Lab, et ne reecrit pas ce fichier.
 *
 * Deux adresses : l'accueil, ou se joue toute la partie, et `/c/<code>`, celle des QR codes
 * du livre. Un chemin et non un parametre (`?c=`) : Safari rechargerait la page precedente
 * quand seul un parametre change. Cette adresse est imprimee dans les livres : elle ne change
 * plus jamais.
 *
 * Les deux attendent le livre de la page (`livreCharge` de `livre.ts`, charge une seule fois,
 * quelques secondes au plus) : le jeu se cree avec le livre publie, sa copie gardee ou la demo,
 * et n'en change plus tant que la page reste ouverte.
 */

/** Ce que montre la page tant que le livre n'est pas la : c'est rare, et court. */
function OuvertureDuLivre() {
  return (
    <p role="status" className="text-sm text-muted-foreground">
      Ouverture du livre...
    </p>
  );
}

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: async () => {
    await livreCharge();
  },
  pendingComponent: OuvertureDuLivre,
  component: HomePage,
});

/**
 * Le lecteur a scanne un QR code avec l'appareil photo de son telephone. Le code est lu une
 * fois, dans le livre charge et avant tout affichage, puis l'adresse est remplacee par
 * l'accueil : recharger la page ne rejoue pas le choix, et le bouton retour ne le repropose pas.
 */
export const codeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/c/$code",
  beforeLoad: async ({ params, preload }) => {
    await livreCharge();
    if (!preload) jeuParDefaut().recevoir(params.code, "lien");
    throw redirect({ to: "/", replace: true });
  },
  pendingComponent: OuvertureDuLivre,
});

export const appRoutes = [homeRoute, codeRoute];
